import '../styles/index.scss';

import 'jquery-confirm/css/jquery-confirm.css';

import 'lite-youtube-embed/src/lite-yt-embed.css';
import 'lite-youtube-embed/src/lite-yt-embed.js';
import 'imports-loader?imports=default|jquery|$!owl.carousel';
import 'popper.js';
import * as bootstrap from 'bootstrap';
import axios from "axios";

import '@fortawesome/fontawesome-free/css/all.min.css';

import flatpickr from "flatpickr";
require('flatpickr/dist/flatpickr.min.css');

import './text-resize';
import './addtohomescreen.js';

import civicCookie from './civic-cookie';

import {
  debounce,
  debounceSearch,
  debounceAllSearch,
  debounceTabletStructure
} from './helpers';

civicCookie();

var Mustache = require('mustache');
var jconfirm = require('jquery-confirm');

if ('serviceWorker' in navigator) {
  window.addEventListener('load', function () {
    navigator.serviceWorker.register('/sw.js');
  });
}

axios.defaults.xsrfHeaderName = 'X-CSRFToken';
axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.withCredentials = true;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

axios.interceptors.response.use(
  function (response) {
      const login_url = '/accounts/login/';
      const is_login_redir = response.request.responseURL.includes(login_url);

      if(is_login_redir) {
        const url = new URL(response.request.responseURL);
        const next = url.searchParams.get("next");
        const is_api_redir = next.includes('api/');

        if(is_api_redir) {
          const new_url = new URL(`${window.location.origin}${login_url}`);
          new_url.searchParams.set('next', window.location.href);
          window.location.replace(new_url.toString());
        }else{
          window.location.replace(response.request.responseURL);
        }
      }

    return response;
  },
  function (error) {

    const toast_error = document.getElementById('toast_error');
    const toastBootstrap = bootstrap.Toast.getOrCreateInstance(toast_error);
    toastBootstrap.show();

    return Promise.reject(error);
  }
);


$(document).ready(function () {
  onPageLoad();
  js_router();
});

function js_router() {
    // Work through url backwards until match found
    var path = window.location.pathname;

    $('.container').off('click');
    $(document).off('submit');

    if(path == "/") {
        bind_home();
    } else {
        path = (path.length && path[0] == '/') ? path.slice(1) : path;
        var path_parts = path.split("/");

        for(var i=path_parts.length; i!=-1; i--) {
            var part = path_parts[i];

            switch(part) {
                case 'search':
                    return bind_search();
                // case 'account':
                //     return bind_account();
            }
        }
    }
}

function bind_home() {
  $('.owl-carousel').owlCarousel({
    margin: 10,
    items: 2
  });
}

function bind_search() {
  console.log('search');

  var terms = $('.search-all-wrapper #all_terms').val();
  var filter = $('.search-all-wrapper #type_filter').val();
  var sa_filter = $('.search-all-wrapper #sa_filter').val();
  if(terms !== "" || filter !== "" || sa_filter !== "") {
      debounceAllSearch();
  }
}

function onPageLoad() {
  flatpickr('.dateinput', {
    dateFormat: 'd/m/Y'
  });

  addToHomescreen({
    detectHomescreen: true,
    lifespan: 30
  });

  $('.article .back-btn').on('click', function() {
    window.history.back();
  });

  jQuery.fontSizer({selector:".content-wrapper"});

  debounceTabletStructure();

  window.addEventListener('resize', () => {
    debounceTabletStructure();
  });

  $('#course_terms').on('keyup', function() {
    debounceSearch();
  });

  $('.course-form').on('submit', function(e) {
    e.preventDefault();
    debounceAllSearch();
  });

  $('#all_terms').on('keyup', function(e) {
    e.preventDefault();
    debounceAllSearch();
  });

  $('.search-form').on('submit', function(e) {
    e.preventDefault();
    debounceAllSearch();
  });

  $('.search-all-wrapper #type_filter, .search-all-wrapper #sa_filter').on('change', function() {
    debounceAllSearch();
  });

  $('.search-all-wrapper .load-more').on('click', function() {
    let current_page = $(this).attr('data-current_page');
    debounceAllSearch(current_page);
  });

  $('.search-all-wrapper .reset').on('click', function() {
    $('.search-all-wrapper .all-results').empty();
    $('.search-all-wrapper .results-wrapper').hide();
  });

  // $('.user-wrapper .button-wrapper').on('click', function() {
  //   $('.user-wrapper').hide();
  //   $('.account-form').show();
  // });

  // $('.account-form .back-btn').on('click', function() {
  //   $('.user-wrapper').show();
  //   $('.account-form').hide();
  // });

  // from courses page add to my courses button
  var debounceAddCourse = debounce(function() {
      $('.sa-picker-wrapper .status').text('saving');

      axios.post('/courses/api/my_courses/add/', {
        course_id: $('.course-detail-wrapper .my-course-bar').data('course_id'),
        subcourse_uio_id: $('.subcourse-list .list-group-item.selected').data('subcourse_id')
      }).then(function(response) {
        $('.course-detail-wrapper .add').hide();
        $('.course-detail-wrapper .added').show();
      }).catch(function(err) {
        $('#course_results').html("Couldn't save");
      });
  }, 250);

  $('.course-detail-wrapper .my-course-bar .add').on('click', function() {
    debounceAddCourse(this);
  });

  // add fav from search result star
  var debounceSearchAddCourse = debounce(function(ele) {
    let result_ele = $(ele).closest('.course-result');
    let loader = $(ele).next('.loader');
    let action = $(ele).data('action');

    $(ele).removeClass('error');
    loader.show();
    $(ele).hide();

    axios.post(`/courses/api/my_courses/${action}/`, {
      action: action,
      course_id: $(result_ele).data('course_id')
    }).then(function(response) {
      loader.hide();
      if(action == 'add') {
        $(result_ele).find('.added').show();
      }else{
        $(result_ele).find('.not-added').show();
      }
    }).catch(function(err) {
      loader.hide();
      $(ele).addClass('error').show();
    });
  }, 250);

  $('#course_results').on('click', '.course-result .fav', function(e) {
    e.preventDefault();
    debounceSearchAddCourse(this);
  });

  var debounceRemoveCourse = debounce(function(remove_course_ele) {
    let course_id = $(remove_course_ele).data('course_id');

    $.confirm({
        title: 'Remove Course',
        content: 'Are you sure',
        type: 'blue',
        buttons: {
            ok: {
                text: "Yes",
                btnClass: 'btn-primary',
                keys: ['enter'],
                action: function(){
                  $(remove_course_ele).hide();
                  $(remove_course_ele).next().show();

                  axios.post('/courses/api/my_courses/remove/', {
                    course_id: course_id
                  }).then(function(response) {
                    $(remove_course_ele).closest('.course-card').remove();

                    if(!$('.course-card').length){
                      $('.empty-state').show();
                    }
                  }).catch(function(err) {
                    console.log('error');
                  });
                }
            },
          cancel: function(){
          }
        }
    });
  }, 250);

  $('.course-list .course-card .remove-course').on('click', function() {
    debounceRemoveCourse(this);
  });

  var debounceAddBookmark = debounce(function(ele) {
    var action = $(ele).data('action');

    $('.bookmark .bookmark-icon').hide();
    $('.bookmark .loader').show();
    axios.post('/api/bookmark/', {
      action: action,
      article_id: $('.bookmark').data('article_id')
    }).then(function(response) {
      $('.bookmark .loader').hide();

      if(action == 'add') {
        $('.bookmark .is_bookmarked').show();
      }else{
        $('.bookmark .not_bookmarked').show();
      }

      $('.bookmark').removeClass('error');
    }).catch(function(err) {
      $('.bookmark .loader').hide();

      if(action == 'add') {
        $('.bookmark .not_bookmarked').show();
      }else{
        $('.bookmark .is_bookmarked').show();
        $('.bookmark').addClass('error');
      }
    });
  }, 250);


  $('.bookmark-icon').on('click', function() {
    debounceAddBookmark(this);
  });

  var debounceRemoveBookmark = debounce(function(remove_book_ele) {

    $.confirm({
        title: 'Remove Bookmark',
        content: 'Are you sure',
        type: 'blue',
        buttons: {
            ok: {
                text: "Yes",
                btnClass: 'btn-primary',
                keys: ['enter'],
                action: function(){
                  axios.post('/api/bookmark/', {
                    action: 'remove',
                    article_id: $(remove_book_ele).data('article_id')
                  }).then(function(response) {
                    remove_book_ele.closest('.page').remove();

                    if(!$('.page').length){
                      $('.page-empty').show();
                    }

                  }).catch(function(err) {
                    console.log('error');
                  });
                }
            },
          cancel: function(){
          }
        }
    });
  }, 250);

  $('.bookmark-list .page .remove').on('click', function() {
    debounceRemoveBookmark($(this));
  });

  $('.subcourse-list .list-group-item').on('click', function() {
    $('.subcourse-list .list-group-item').removeClass('selected');
    $(this).addClass('selected');
  });

  $('.subcourse-apply-btn').on('click', function() {
    var url = $('.subcourse-list .list-group-item.selected').data('apply_url');
    if(url) {
      window.open(url, '_blank').focus();
    }
  });

  $('.share-button').on('click', function() {
    var url = $(this).data('page_url');
    var title = $(this).data('page_title');

    $('.page-share-popup').remove();
    var template = document.getElementById('share_tmpl').innerHTML;
    var rendered = Mustache.render(template, {
      url: url,
      title: title
    });
    $('.share-wrapper').append(rendered);

  });

  $('.share-wrapper').on('click', '.close', function() {
    $('.page-share-popup').removeClass("show");
  });

  $('.share-wrapper').on('click', '.field button', function() {
    const field = $(".page-share-popup .field"),
    input = $(".page-share-popup .field input"),
    copy = $(".page-share-popup .field button");

    input[0].select(); //select input value
    if (document.execCommand("copy")) { //if the selected text copy
      field.addClass("active");
      copy.text("Copied");
      setTimeout(() => {
        window.getSelection().removeAllRanges(); //remove selection from document
        field.removeClass("active");
        copy.text("Copy");
      }, 3000);
    }
  });

};
